import React, { useId } from 'react'

import { cx } from '@linaria/core'
import * as RadixCheckbox from '@radix-ui/react-checkbox'

export const Checkbox: React.FC<{
  id?: string
  name?: string
  label?: React.ReactNode
  justify?: 'center' | 'start' | 'end'
  disableLabelBold?: boolean
  checked?: boolean
  defaultChecked?: boolean
  onCheckedChange?: (checked: boolean | 'indeterminate') => void
  disabled?: boolean
}> = (props) => {
  const defaultId = useId()
  return (
    <div
      className={cx(
        'flex gap-2 items-center',
        props.justify === 'center' && 'justify-center',
        props.justify === 'start' && 'justify-start',
        props.justify === 'end' && 'justify-end'
      )}
    >
      <RadixCheckbox.Root
        name={props.name}
        id={props.id ?? defaultId}
        checked={props.checked}
        className="w-[18px] h-[18px] flex-shrink-0 bg-[#d9d9d9] rounded-sm grid place-items-center"
        onCheckedChange={props.onCheckedChange}
        defaultChecked={props.defaultChecked}
        disabled={props.disabled}
      >
        <RadixCheckbox.Indicator className="w-[12px] h-[12px] rounded-sm bg-[#2e3a59]" />
      </RadixCheckbox.Root>

      <label
        htmlFor={props.id ?? defaultId}
        className={cx('text-sm block', props.disableLabelBold && 'font-bold')}
      >
        {props.label}
      </label>
    </div>
  )
}
